"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredicateStringElementParser = void 0;
const ParenthesisOpen_1 = require("./string-elements/ParenthesisOpen");
const ParenthesisClose_1 = require("./string-elements/ParenthesisClose");
const StringElementCollection_1 = require("./string-elements/collection/StringElementCollection");
const MissingParenthesesError_1 = require("./errors/MissingParenthesesError");
const UnknownElementError_1 = require("./errors/UnknownElementError");
// noinspection JSMethodCanBeStatic
/**
 * Converts a predicate string to an object representation of that string
 *
 * "1 AND NOT (2 OR 3)"
 * becomes
 * [AtomicPredicateString(1), OperatorString(AND NOT), ParenthesisOpen(), AtomicPredicateString(2), OperatorString(OR), AtomicPredicateString(3)]
 *
 * Also assigns nesting levels to elements and links the elements together through setNext() and setPrevious().
 * `2 OR 3` from the upper example would have a nesting level of 1.
 * `AtomicPredicateString(1).getNext()` would return `OperatorString(AND NOT)`
 */
class PredicateStringElementParser {
    constructor(predicateString, config) {
        this.nestingIndex = 0;
        this.predicateString = predicateString;
        this.config = config;
    }
    parseStringElements() {
        const stringElements = new StringElementCollection_1.StringElementCollection(); // object representation of the string
        while (this.predicateString.length) {
            this.consumePredicateStringSequentially(stringElements);
        }
        this.validate(stringElements);
        return stringElements;
    }
    consumePredicateStringSequentially(stringElements) {
        const elementClass = stringElements.getNextPossibleElementClasses()
            .find(elementClass => this.isCorrectElementClass(elementClass));
        if (!elementClass) {
            throw new UnknownElementError_1.UnknownElementError(this.predicateString);
        }
        const element = this.parseStringElement(elementClass);
        this.removeFromPredicateString(element);
        stringElements.append(element);
    }
    isCorrectElementClass(elementClass) {
        return elementClass.getMatcher(this.config).test(this.predicateString);
    }
    parseStringElement(elementClass) {
        if (elementClass === ParenthesisClose_1.ParenthesisClose) {
            this.nestingIndex--;
        }
        const parsedString = elementClass.getMatcher(this.config).exec(this.predicateString)[0];
        const element = new elementClass(this.nestingIndex, parsedString);
        if (elementClass === ParenthesisOpen_1.ParenthesisOpen) {
            this.nestingIndex++;
        }
        return element;
    }
    removeFromPredicateString(element) {
        this.predicateString = this.predicateString.substring(element.getParsedString().length, this.predicateString.length).trim();
    }
    validate(stringElements) {
        const amountOfOpeningParentheses = stringElements.getByType(ParenthesisOpen_1.ParenthesisOpen).length;
        const amountOfClosingParentheses = stringElements.getByType(ParenthesisClose_1.ParenthesisClose).length;
        if (amountOfClosingParentheses !== amountOfOpeningParentheses) {
            throw new MissingParenthesesError_1.MissingParenthesesError(amountOfOpeningParentheses, amountOfClosingParentheses);
        }
    }
}
exports.PredicateStringElementParser = PredicateStringElementParser;
//# sourceMappingURL=PredicateStringElementParser.js.map